module.exports = import("node:fs/promises");;